// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1FoWu","circle":"styles_circle__LZXLT","icon":"styles_icon__4AOo8","text":"styles_text__3N-Xj","smallerButtonText":"styles_smallerButtonText__1nc41"};